module.exports = __webpack_public_path__ + "static/media/qr-code-screen-2.832acb53.jpg";